(function() {
    'use strict';
    angular.module('doclr.dashboard', [
            'doclr.components.agenda',
            'doclr.components.adminagendacomponents',
            'doclr.resources.api',
            'doclr.praktijk',
            'ui.router',
            'ui.bootstrap.typeahead'
        ])
        .config(function($stateProvider, agendaNestedStatesConfigurator) {
            $stateProvider.state('dashboard', {
                url: '/dashboard',
                resolve: {
                    agendas: function(AgendaOverzicht, praktijkContext) {
                        return AgendaOverzicht.get(praktijkContext.id);
                    },
                    slicesLoader: function(slicesService, agendaDashboardCriteriaFactory, userContext, agendas) {
                        var criteria = agendaDashboardCriteriaFactory(agendas, userContext.defaultAgendaId);
                        return slicesService.load(criteria);
                    },
                    afspraakTypes: function(AfspraakMogelijkheidTypes, praktijkContext) {
                        return AfspraakMogelijkheidTypes.getTypes(praktijkContext.id);
                    }
                },
                views: {
                    '' : {
                        templateUrl : '/partials/components/page.with.sidebar.html'
                    },
                    'content@dashboard': {
                        templateUrl: '/partials/dashboard/dashboard.html',
                        controller: function($scope, agendas, afspraakTypes) {
                            $scope.agendas = agendas;
                            $scope.afspraakTypes = afspraakTypes;

                            $scope.agendaContextOptions = {
                                agendas: agendas
                            };
                        }
                    },
                    'sidebar@dashboard' : {
                        templateUrl: '/partials/dashboard/dashboard.sidebar.html',
                        controller: function($scope,agendas, slicesService, agendaBoundaries) {
                            $scope.slicesLoader = slicesService.slicesLoader;
                            $scope.agendaBoundaries = agendaBoundaries;
                            $scope.agendas = agendas;
                            $scope.onAgendaClicked = function(agendaId){
                                $('.page-with-sidebar').removeClass('active');
                                slicesService.slicesLoader.navigator.wijzigDagEnAgenda(undefined,agendaId);
                            };
                        }
                    },
                    'menutop@': {
                        templateUrl: '/partials/components/afspraak.zoeken.html',
                        controller: 'afspraakZoekenController'
                    }
                }
            });

            agendaNestedStatesConfigurator($stateProvider, 'dashboard');
        });
})();
